import APIAccessor from '@/util/APIAccesser'
import { StoreBase } from '../StoreBase'

class MailAddressRegistrationStore implements StoreBase {
  /* eslint-disable class-methods-use-this */
  createStore() {
    /**
     * メールアドレス変更のURLを送信する
     * @see https://pitchbase.atlassian.net/wiki/spaces/SL01/pages/1669562369/URL+API
     * @param {string} mailAddress 登録するメールアドレス
     * @return 送信結果
     */
    const sendMailAddressChanged = async (mailAddress: string) => {
      try {
        const result = await APIAccessor.request({
          path: `manage/mail_address_change_token`,
          method: 'POST',
          data: {
            mailAddress,
          },
        })
        return {
          isSuccess: true,
          res: result,
        }
      } catch (e) {
        console.warn(e)
        // ネットワークエラー対策
        if (e.response) {
          return { isSuccess: false, res: e }
        }
        // eslint-disable-next-line @typescript-eslint/camelcase
        return { isSuccess: false, res: { response: { data: { error_code: 'NETWORK_ERROR' } } } }
      }
    }

    return {
      sendMailAddressChanged,
    }
  }
  /* eslint-enable class-methods-use-this */
}

export default new MailAddressRegistrationStore().createStore()
